import { JsonSchema, RowDataReducerAction, RowData } from "../../../../types";
import { BULK_IMPORT_FIELD_KEYS } from "../../constants";
import { downloadFileUploadTemplate } from "./downloadFileUploadTemplate";

export async function handleFileTemplateDownload(
  schema: JsonSchema,
  setupName: string,
): Promise<void> {
  await downloadFileUploadTemplate({ schema, setupName });
}

export const resetFileUploadData = (
  dispatch: React.Dispatch<RowDataReducerAction>,
): void => {
  dispatch({
    type: "UPDATE_ROW_DATA_REDUCER_STATE",
    payload: { fileRowDataList: [] },
  });
};

export const resetFileUploadDataWithErrors = (
  dispatch: React.Dispatch<RowDataReducerAction>,
): void => {
  dispatch({
    type: "UPDATE_ROW_DATA_REDUCER_STATE",
    payload: { fileRowDataErrorsList: [] },
  });
};

export const updateFileUploadData = (
  dispatch: React.Dispatch<RowDataReducerAction>,
  data: RowData[],
): void => {
  dispatch({
    type: "UPDATE_ROW_DATA_REDUCER_STATE",
    payload: { fileRowDataList: data },
  });
};

export const updateFileUploadDataWithErrors = (
  dispatch: React.Dispatch<RowDataReducerAction>,
  data: RowData[],
): void => {
  dispatch({
    type: "UPDATE_ROW_DATA_REDUCER_STATE",
    payload: { fileRowDataErrorsList: data },
  });
};

export const hasValidationErrors = (fileRowDataList: RowData[]) =>
  fileRowDataList.some(
    (row) =>
      (row[BULK_IMPORT_FIELD_KEYS.RECORD_VALIDATION_STATUS] as string)?.toLowerCase?.() ===
      "failure",
  );
